import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager/Picker/StructuredPicker/index.styles.css'
import { CostCenterOption } from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager/Picker/hooks/useCostCenterByLegalEntities'

interface Props {
  option: CostCenterOption
  isSelected: boolean
  onSelect: (option: CostCenterOption) => void
}

const PickerOption = ({ option, isSelected, onSelect }: Props) => {
  const handleClick = () => {
    // Ignore click if already selected
    if (isSelected) return
    onSelect(option)
  }

  return (
    <Box
      key={option.id}
      alignItems="center"
      justifyContent="spaceBetween"
      cursor={isSelected ? 'default' : 'pointer'}
      flexDirection="row"
      gap="s8"
      paddingX="s16"
      paddingY="s12"
      width="full"
      onClick={handleClick}
      className={isSelected ? 'StructuredPicker_optionSelected' : 'StructuredPicker_optionHover'}
    >
      <Text.Normal size="200" ellipsis>
        {option.name}
      </Text.Normal>
      {isSelected && <Icon.Medium icon="check-circle" color="viridian800" />}
    </Box>
  )
}

export default PickerOption
